import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { SIDEBAR_COLLAPSED } from '../../shared/utils/app.const';
import { setSidebarCollapsed, toggleSidebar } from './common.actions';

@Injectable()
export class CommonEffect {
  private actions$ = inject(Actions);

  saveSidebarState$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(toggleSidebar, setSidebarCollapsed),
        tap((action) => {
          if (action.type === '[COMMON] Toggle sidebar') {
            const currentState = localStorage.getItem(SIDEBAR_COLLAPSED) === 'true';
            localStorage.setItem(SIDEBAR_COLLAPSED, (!currentState).toString());
          } else if (action.type === '[COMMON] Set sidebar collapsed') {
            localStorage.setItem(SIDEBAR_COLLAPSED, (action as any).collapsed.toString());
          }
        }),
      ),
    { dispatch: false },
  );
}
